import RedirectService from './RedirectService';
import MessageService from './MessageService';
import ResultCollector from './ResultCollector';
import ProxyCollectionSdk from './Proxies/ProxyCollectionSdk';
import CookieConsentManager from './Cookies/CookieConsentManager';
import SessionService from './SessionService';
import FaceService from './FaceService';
import CookieService from './Cookies/CookieService';
import UrlHelper from './UrlHelper';
import Environment from './Environment';
import IdentityService from './IdentityService';
import Dispatcher from './Dispatcher';
import ProxyRecorder from './ProxyRecorder';
import ErrorService from './ErrorService';
import ElementRandomiser from './ElementRandomiser';
import { UiService } from './UiService';
import Test from './Test';
import IdentityAPI from './API/IdentityAPI';
import SessionAPI from './API/SessionAPI';
import FaceAPI from './API/FaceAPI';
import WebCamAccessManager from './WebCamAccessManager';

export default class BaseApp {
    constructor() {
        jsModuleSettings.showReAllow = (jsModuleSettings.showReAllow ?? '').toLowerCase() === 'true';
        const cookieService = new CookieService();
        this.urlHelper = new UrlHelper();
        this.options = window.hfStartOptions;
        jsModuleSettings.isFaceUniquenessEnabled = !!jsModuleSettings.collectionGroupId && !!jsModuleSettings.collectionGroupCompareIdList && !!jsModuleSettings.collectionGroupCompareIdList.length;
        this.environment = new Environment();
        this.proxyCollectionSdk = new ProxyCollectionSdk();

        this.identityService = new IdentityService(this.options, new IdentityAPI(), this.urlHelper);
        this.sessionService = new SessionService(
            window.sessionGuid,
            new SessionAPI(),
            this.proxyCollectionSdk,
            this.environment,
            this.options,
            this.ReasonService
        );
        this.faceService = new FaceService(new FaceAPI());
        this.uiService = new UiService(this.sessionService, this.environment);
        this.messageService = new MessageService(
            window.uiMessages,
            this.options.closingData.message,
            this.sessionService,
            this.uiService
        );
        this.cookieConsentManager = new CookieConsentManager(
            this.sessionService,
            cookieService,
            this.messageService,
            this.uiService,
            jsModuleSettings
        );
        this.redirectService = new RedirectService(
            this.messageService,
            this.urlHelper,
            this.sessionService,
            this.options,
            this.identityService
        );
        this.errorService = new ErrorService(
            this.messageService,
            this.redirectService,
            cookieService,
            this.sessionService,
            this.options
        );
        this.resultCollector = new ResultCollector(this.sessionService);
        this.proxyRecorder = new ProxyRecorder(this.proxyCollectionSdk, this.environment);
        this.test = new Test(
            new ElementRandomiser(),
            this.sessionService,
            this.environment,
            this.uiService,
            this.proxyRecorder,
            this.resultCollector,
            this.redirectService,
            this.errorService,
            this.messageService,
            this.faceService,
            this.options
        );
        this.dispatcher = new Dispatcher(
            this.sessionService,
            this.redirectService,
            this.messageService,
            this.identityService,
            cookieService,
            this.environment,
            this.urlHelper,
            this.proxyRecorder,
            this.options,
            this.test,
            this.errorService
        );
        this.webcamAccessManager = new WebCamAccessManager(
            this.environment,
            this.sessionService,
            this.faceService,
            this.proxyRecorder,
            this.uiService,
            this.options,
            window.jsModuleSettings,
            this.errorService,
            this.test
        );
    }

    async init(environmentCheckResult, skipBeforeUnload = false) {
        this.environment.init(environmentCheckResult);

        this.uiService.init(this.options);

        const recorderOptions = this._getRecorderOptions(this.options);
        await this.proxyCollectionSdk.init({
            recorderOptions: recorderOptions,
            sessionId: this.sessionService.sessionGuid,
            projectKey: this.options.dataCollectionHash,
            environmentDetectionResult: environmentCheckResult.detectorResult
        });

        await this.proxyRecorder.init(this.environment, {
            needProxy: this.options.jsApiEnabled,
            recorderOptions: recorderOptions
        });

        this.dispatcher.init(skipBeforeUnload);

        if (!environmentCheckResult.checksPassed) {
            await this.dispatcher.run();

            return false;
        }

        return true;
    }

    _getRecorderOptions(options) {
        var recordingConfig = recordingModuleSettings.otConfig || '{}';
        //TEMP backward compatibility
        if (recordingConfig.charAt(0) === '"') {
            recordingConfig = recordingConfig.substring(1, recordingConfig.length - 1);
        }
        recordingConfig = recordingConfig.replaceAll('\\', '');
        recordingConfig = JSON.parse(recordingConfig);

        recordingConfig.autoReplyTime = parseInt(window.jsModuleSettings.autoDenyTime);
        recordingConfig.storage = {
            path: 's3://' + options.bucketName + '/' + options.dataCollectionHash
        };
        recordingConfig.recordAudio = recordingModuleSettings.recordAudio === 'true' ? true : false;

        //TEMP backward compatibility
        var vidRes = recordingModuleSettings.videoResolution;

        if (vidRes) {
            if (vidRes.charAt(0) === '"') {
                vidRes = vidRes.substring(1, vidRes.length - 1);
            }
            recordingConfig.videoResolution = vidRes.replaceAll('\\', '');
        }

        var mirrorCfg = recordingModuleSettings.mirrorViewConfig;

        if (mirrorCfg) {
            if (mirrorCfg.charAt(0) === '"') {
                mirrorCfg = mirrorCfg.substring(1, mirrorCfg.length - 1);
            }
            recordingConfig.mirrorViewConfig = mirrorCfg.replaceAll('\\', '');
        }

        return recordingConfig;
    }
}
